import { NavMenuItemCombinedProps } from './types';

const usePresenter = (props: NavMenuItemCombinedProps): NavMenuItemCombinedProps => {
  return props;
};

export default usePresenter;
